import matrixClient from '@mapbox/mapbox-sdk/services/matrix';
import { MAPBOX_TOKEN } from 'shared/constants';

const requestDrivingTrafficFromMapbox = async (origin, destination) =>
  matrixClient({ accessToken: MAPBOX_TOKEN })
    .getMatrix({
      points: [{ coordinates: origin }, { coordinates: destination }],
      profile: `driving-traffic`,
    })
    .send();

export default requestDrivingTrafficFromMapbox;
